import React from 'react'
import { classNames } from './../../utils/styles'
import { elementChildren } from './../../utils/components'
import PropTypes from 'prop-types'
import styles from './ButtonGroup.scss'

export default function ButtonGroup({ children, center }) {
  const className = classNames({
    [styles.ButtonGroup]: true,
    [styles.CenterGroup]: center,
  })

  const contents = elementChildren(children).map((child, index) =>
    React.cloneElement(child, {
      key: index,
      className: styles.Item,
    }),
  )

  return <div className={className}>{contents}</div>
}

ButtonGroup.propTypes = {
  children: PropTypes.any,
  center: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/ButtonGroup/index.js